export const getUserAccountType = (userData): string => {
    return userData.accessType || '';
};
